import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private _storage: Storage | null = null;

  constructor(private storage: Storage) {
    this.init();
  }

  async init() {
    const storage = await this.storage.create();
    this._storage = storage;
  }

  public async set(
    key:
      | 'token'
      | 'plan'
      | 'name'
      | 'diet_journey'
      | 'sign_up_value'
      | 'currency'
      | 'applied_discount'
      | 'last_water_intake'
      | 'last_sleep_log'
      | 'last_mood_log',
    value: any
  ) {
    await this._storage?.set(key, value);
  }

  public async get(
    key:
      | 'token'
      | 'plan'
      | 'name'
      | 'diet_journey'
      | 'sign_up_value'
      | 'currency'
      | 'applied_discount'
      | 'last_water_intake'
      | 'last_sleep_log'
      | 'last_mood_log'
  ): Promise<any> {
    this._storage = await this.storage.create();
    return await this._storage?.get(key);
  }

  public async remove(
    key: 'token' | 'plan' | 'diet_journey' | 'applied_discount'
  ) {
    this._storage = await this.storage.create();
    return this._storage?.remove(key);
  }

  public async clear() {
    this._storage = await this.storage.create();
    return this._storage?.clear();
  }
}
